'use client';

import { useEffect } from 'react';

const ProductVideoPlayer = ({ url, isPlaying, poster }) => {
  useEffect(() => {
    let hls;
    const video = document.getElementById(url);

    if (!video || typeof window === 'undefined') return;

    const setupHls = async () => {
      const HlsModule = await import('hls.js');
      const Hls = HlsModule.default;

      if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(url);
        hls.attachMedia(video);

        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          if (isPlaying) {
            video.play();
          }
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = url;
        video.addEventListener('loadedmetadata', function () {
          if (isPlaying) {
            video.play();
          }
        });
      }
    };

    setupHls();

    return () => {
      hls?.destroy();
    };
  }, [url, isPlaying]);

  return (
    <video
      className="mx-auto min-h-[300px] lg:min-h-[550px] max-h-[300px] lg:max-h-[550px] object-cover"
      height="550px"
      poster={poster}
      autoPlay
      muted
      id={url}
      controls={false}
    />
  );
};

export default ProductVideoPlayer;
